export default "__VITE_PUBLIC_ASSET__eaade820__"